export enum TiposMenuEnum {
    Ninos = '1100002',
    Padres = '1100001',
}
  